var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationcarouselTwoColor1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 136,
    viewBox: "0 0 253 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M63.1591 29.3337C42.1549 35.1576 26.5687 49.9179 23.4691 67.7774C20.8798 82.8265 27.0664 99.4544 63.4867 104.191C134.349 113.412 207.398 114.49 224.338 89.6202C241.279 64.7505 218.095 24.9264 182.128 22.1701C153.589 19.9777 104.191 17.9612 63.1591 29.3337Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.043 25.8594H99.9588C96.629 25.8594 93.9297 27.7922 93.9297 30.1765V102.011C93.9297 104.396 96.629 106.329 99.9588 106.329H153.043C156.372 106.329 159.072 104.396 159.072 102.011V30.1765C159.072 27.7922 156.372 25.8594 153.043 25.8594Z",
    fill: "#263155"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M126.5 103.867C129.106 103.867 131.219 102.354 131.219 100.488C131.219 98.6221 129.106 97.1094 126.5 97.1094C123.894 97.1094 121.781 98.6221 121.781 100.488C121.781 102.354 123.894 103.867 126.5 103.867Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.714 32.8398H100.279V95.4947H152.714V32.8398Z",
    fill: "#006199"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M120.497 91.7665C121.443 91.7665 122.21 91.2172 122.21 90.5395C122.21 89.8619 121.443 89.3125 120.497 89.3125C119.55 89.3125 118.783 89.8619 118.783 90.5395C118.783 91.2172 119.55 91.7665 120.497 91.7665Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M126.501 91.7665C127.447 91.7665 128.214 91.2172 128.214 90.5395C128.214 89.8619 127.447 89.3125 126.501 89.3125C125.554 89.3125 124.787 89.8619 124.787 90.5395C124.787 91.2172 125.554 91.7665 126.501 91.7665Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M132.505 91.7665C133.451 91.7665 134.218 91.2172 134.218 90.5395C134.218 89.8619 133.451 89.3125 132.505 89.3125C131.558 89.3125 130.791 89.8619 130.791 90.5395C130.791 91.2172 131.558 91.7665 132.505 91.7665Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M145.722 39.75H107.279V63.2484H145.722V39.75Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M134.25 67.7812H107.279V69.9331H134.25V67.7812Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M145.722 67.7812H136.07V69.9331H145.722V67.7812Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M119.879 74.3789H107.279V76.5307H119.879V74.3789Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M145.722 74.3789H122.557V76.5307H145.722V74.3789Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M136.392 80.9844H107.279V83.1362H136.392V80.9844Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0189 32.8398H35.584V95.4947H88.0189V32.8398Z",
    fill: "#006199"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M55.8015 91.7665C56.7479 91.7665 57.5151 91.2172 57.5151 90.5395C57.5151 89.8619 56.7479 89.3125 55.8015 89.3125C54.8551 89.3125 54.0879 89.8619 54.0879 90.5395C54.0879 91.2172 54.8551 91.7665 55.8015 91.7665Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M61.8054 91.7665C62.7518 91.7665 63.519 91.2172 63.519 90.5395C63.519 89.8619 62.7518 89.3125 61.8054 89.3125C60.859 89.3125 60.0918 89.8619 60.0918 90.5395C60.0918 91.2172 60.859 91.7665 61.8054 91.7665Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M67.8093 91.7665C68.7557 91.7665 69.5229 91.2172 69.5229 90.5395C69.5229 89.8619 68.7557 89.3125 67.8093 89.3125C66.8629 89.3125 66.0957 89.8619 66.0957 90.5395C66.0957 91.2172 66.8629 91.7665 67.8093 91.7665Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M81.0266 39.75H42.584V63.2484H81.0266V39.75Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M69.5543 67.7812H42.584V69.9331H69.5543V67.7812Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M81.0266 67.7812H71.375V69.9331H81.0266V67.7812Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M55.184 74.3789H42.584V76.5307H55.184V74.3789Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M81.0264 74.3789H57.8613V76.5307H81.0264V74.3789Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M71.6963 80.9844H42.584V83.1362H71.6963V80.9844Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M217.41 32.8398H164.975V95.4947H217.41V32.8398Z",
    fill: "#006199"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M185.19 91.7665C186.137 91.7665 186.904 91.2172 186.904 90.5395C186.904 89.8619 186.137 89.3125 185.19 89.3125C184.244 89.3125 183.477 89.8619 183.477 90.5395C183.477 91.2172 184.244 91.7665 185.19 91.7665Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M191.194 91.7665C192.14 91.7665 192.908 91.2172 192.908 90.5395C192.908 89.8619 192.14 89.3125 191.194 89.3125C190.248 89.3125 189.48 89.8619 189.48 90.5395C189.48 91.2172 190.248 91.7665 191.194 91.7665Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M197.198 91.7665C198.144 91.7665 198.912 91.2172 198.912 90.5395C198.912 89.8619 198.144 89.3125 197.198 89.3125C196.252 89.3125 195.484 89.8619 195.484 90.5395C195.484 91.2172 196.252 91.7665 197.198 91.7665Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M210.415 39.75H171.973V63.2484H210.415V39.75Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M198.943 67.7812H171.973V69.9331H198.943V67.7812Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M210.415 67.7812H200.764V69.9331H210.415V67.7812Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M184.573 74.3789H171.973V76.5307H184.573V74.3789Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M210.423 74.3789H187.258V76.5307H210.423V74.3789Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M201.085 80.9844H171.973V83.1362H201.085V80.9844Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M144.391 106.344C144.391 105.893 143.056 87.3975 143.912 84.6458C144.769 81.894 152.632 68.4419 150.559 66.872C148.486 65.3021 140.895 68.8749 140.895 68.8749C140.895 68.8749 142.281 52.6755 139.005 51.5207C135.729 50.3658 134.273 54.8905 134.273 54.8905L132.528 73.0116L123.885 106.259L144.391 106.344Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M138.552 87.4827C139.655 84.3249 141.312 81.2438 142.37 78.0545C143.069 75.9433 147.593 67.1196 148.859 64.5212C149.25 63.7227 149.584 62.7573 148.828 62.1077C148.572 61.9178 148.255 61.7769 147.903 61.698C147.552 61.6192 147.179 61.605 146.818 61.6566C146.09 61.7655 145.418 62.0169 144.878 62.3829C143.618 63.1768 141.293 67.106 139.592 67.1015C137.532 67.1015 138.502 63.0415 138.445 62.2611C138.212 58.9003 138.559 54.5922 136.725 51.4344C135.365 49.0886 131.988 49.4044 131.194 51.9397C130.4 54.4749 130.432 65.0986 130.432 65.0986C130.432 65.0986 117.252 63.4791 115.003 66.3572C112.754 69.2353 116.553 87.5188 116.553 87.5188L138.552 87.4827Z",
    fill: "#F4A28C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M140.157 115.528L139.918 86.4721L115.291 82.6016L105.375 115.528H140.157Z",
    fill: "#006199"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M140.158 115.531L139.919 86.4746L128.163 84.625L126.059 115.531H140.158Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationcarouselTwoColor1);
export default __webpack_public_path__ + "static/media/Information carousel_Two Color 1.97a1827301603b857abf76112a18201a.svg";
export { ForwardRef as ReactComponent };